import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { WelcomeHero } from "./initialWelcomeMessage";
import Marquee from "react-fast-marquee";
import { Vortex } from "../background";

gsap.registerPlugin(ScrollTrigger);

const MobileHero: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const heroRef = useRef<HTMLDivElement>(null);
    const [heroHeight, setHeroHeight] = useState(0);

    useEffect(() => {
        if (!containerRef.current || !heroRef.current) return;

        // Set hero height dynamically for spacing
        const height = heroRef.current.offsetHeight;
        setHeroHeight(height);

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top top",
                end: () => `+=200%`, // Hero scroll duration proportional to height
                scrub: true,
                pin: true,
                anticipatePin: 1,
            },
        });

        tl.to(heroRef.current, {
            scale: 0.5,
            borderRadius: 40,
            ease: "power1.out",
        });

        return () => {
            ScrollTrigger.getAll().forEach((st) => st.kill());
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className="pb-[calc(var(--vh)*150)] bg-[#00000000]"
        >
            {/* HERO (pinned + zoom out) */}
            <div
                ref={heroRef}
                className="relative z-20 w-full h-[calc(var(--vh)*100)] flex items-center justify-center bg-[#701f84]/60 overflow-hidden"
            >
                <div className="relative z-10 w-full h-full flex items-center justify-center">
                    <WelcomeHero />
                </div>
            </div>

            {/* BACKGROUND SECTION underneath */}
            <div className="absolute top-0 left-0 w-full min-h-[calc(var(--vh)*100)] z-0 flex flex-col items-center justify-center bg-transparent">
                <Vortex
                    backgroundColor="transparent"
                    particleCount={700}
                    baseHue={220}
                    baseSpeed={0.0}
                    rangeSpeed={1.5}
                    className="flex items-center justify-center w-full h-[calc(var(--vh)*100)]"
                >
                    <Marquee gradient={true} gradientColor={"transparent"} speed={100}>
            <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 bg-clip-text text-transparent whitespace-nowrap text-4xl">
              RGU MOTORSPORTS
            </span>
                    </Marquee>
                </Vortex>
            </div>
        </div>
    );
};

export default MobileHero;